const noteRound = (value) => {
    if (value === 10 || value === null) {
        return value;
    } else {
        return value.toFixed(1);
    }

}

const currencyRound = (value) => {
    if (value) {
        return value.toFixed(2);
    } else {
        return "";
    }

}

const brlFormatter = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

// Diferente do currencyRound, formata zero ("R$ 0,00") e já inclui o símbolo.
const currencyBRL = (value) => {
    if (value === null || value === undefined || value === "" || Number.isNaN(Number(value))) {
        return "--";
    }
    return brlFormatter.format(Number(value));
}

export {
    noteRound,
    currencyRound,
    currencyBRL
}